import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { coerceToStringArray } from "@/core/lib/search-params";
import { appStore } from "@/core/lib/state-xstate";

const searchSchema = z.object({
  c: z.string().optional(),
  ds: z.preprocess(coerceToStringArray, z.array(z.uuid())).optional(),
  col: z.preprocess(coerceToStringArray, z.array(z.uuid())).optional(),
});

export const Route = createFileRoute("/_protected/")({
  validateSearch: searchSchema,
  loaderDeps: ({ search }) => ({
    id: search.c,
    ds: search.ds,
    col: search.col,
  }),
  loader: ({ deps }) => {
    const { id, ds, col } = deps;

    appStore.send({
      type: "setLastConversation",
      value: id ? { id, ds, col } : { id: null },
    });
  },
});
